import { call, put, all } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as actions from '../actions/tn';
import { post, get, del, axiosPut } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* getVehiclesList({ payload }) {
  try {
    const response = yield call(post, '/vehicles/list', payload);
    yield put(actions.getVehiclesListSuccess(response));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getVehiclesListFail());
  }
}

export function* addVehicle({ payload }) {
  try {
    yield call(post, '/vehicles', payload);
    yield put(actions.addVehicleSuccess());
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.addVehicleFail());
  }
}

export function* getDriversList({ payload }) {
  try {
    const response = yield call(post, '/drivers/list', payload);
    yield put(actions.getDriversListSuccess(response));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getDriversListFail());
  }
}

export function* addDriver({ payload }) {
  try {
    yield call(post, '/drivers', payload);
    yield put(actions.addDriverSuccess());
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.addDriverFail());
  }
}

export function* getPackingTypeList({ payload }) {
  try {
    const response = yield call(post, '/packing/list', payload);
    yield put(actions.getPackingTypeListSuccess(response));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getPackingTypeListFail());
  }
}

export function* addPackingType({ payload }) {
  try {
    yield call(post, '/packing', payload);
    yield put(actions.addPackingTypeSuccess());
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.addPackingTypeFail());
  }
}

export function* saveTn({ payload }) {
  try {
    const response = yield call(post, '/ttn', {
      docTypeNumId: 4,
      ttnDocumentNumId: null,
      ...payload
    });
    yield put(actions.saveTnSuccess(response.ttnDocumentNumId));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.saveTnFail());
  }
}

export function* getTnList({ payload }) {
  try {
    const response = yield call(post, '/ttn/list', payload);
    yield put(actions.getTnListSuccess(response));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getTnListFail());
  }
}

export function* confirmTnByList({ payload }) {
  let driverResponse = null;
  let packingResponse = null;
  let vehicleResponse = null;
  let trailerResponse = null;
  let responsiblePersonResponse = null;
  let transportCompanyResponse = null;
  if (payload.driverNumId) {
    driverResponse = yield call(get, `/drivers/${payload.driverNumId}`);
  }
  if (payload.vehicleNumId) {
    vehicleResponse = yield call(get, `/vehicles/${payload.vehicleNumId}`);
  }
  if (payload.trailerNumId) {
    trailerResponse = yield call(get, `/vehicles/${payload.trailerNumId}`);
  }
  if (payload.packingTypeNumId) {
    packingResponse = yield call(get, `/packing/${payload.packingTypeNumId}`);
  }
  if (payload.responsiblePersonNumId) {
    responsiblePersonResponse = yield call(get, `/responsible_person/${payload.responsiblePersonNumId}`);
  }
  if (payload.transportCompanyNumId) {
    transportCompanyResponse = yield call(get, `/transport_company/${payload.transportCompanyNumId}`);
  }
  yield put(actions.setTnSuccess({
    dateTn: payload.dateTn,
    docNum: payload.docNum,
    docNumId: payload.docNumId,
    note: payload.note,
    docStatus: payload.docStatus,
    driverName: payload.driverName,
    driverNameShort: payload.driverNameShort,
    expeditorFlag: payload.expeditorFlag,
    shippingDocuments: payload.shippingDocuments,
    weightSeparation: payload.weightSeparation,
    ...(driverResponse && driverResponse),
    ...(packingResponse && packingResponse),
    ...(vehicleResponse && vehicleResponse),
    ...(trailerResponse && {
      trailerNum: trailerResponse.vehicleId,
      trailerNumId: trailerResponse.vehicleNumId
    }),
    ...(responsiblePersonResponse && responsiblePersonResponse),
    ...(transportCompanyResponse && transportCompanyResponse),
    updateTnFromTab: payload.updateTnFromTab
  }));
}

export function* getTnPieceList({ payload }) {
  try {
    const response = yield call(post, '/ttn/pieceList', payload);
    yield put(actions.getTnPieceListSuccess(response));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getTnPieceListFail());
  }
}

export function* confirmTn({ payload }) {
  try {
    yield all(payload.ttnData.map((ttnData) => call(axiosPut, '/ttn', { ...ttnData })));
    yield all(payload.pKeys.map((pKey) => call(get, `/reports/document?docStatus=${payload.docStatus}&pKey=${pKey}`)));
    yield put(actions.confirmTnSuccess());
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.confirmTnFail());
  }
}

export function* addPieceToTn({ payload }) {
  try {
    yield call(post, 'ttn/add_piece', payload);
    yield put(actions.addPieceToTnSuccess());
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.addPieceToTnFail());
  }
}

export function* deletePieceFromTn({ payload }) {
  try {
    yield call(del, '/ttn/delete_piece', payload);
    yield put(actions.deletePieceFromTnSuccess());
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.deletePieceFromTnFail());
  }
}

export function* updateTn({ payload }) {
  try {
    yield call(axiosPut, '/ttn', payload);
    yield put(actions.updateTnSuccess({ updateByModal: payload.updateByModal }));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.updateTnFail());
  }
}

export function* deleteTn({ payload }) {
  try {
    yield call(del, `/ttn/${payload.ttnDocumentNumId}`);
    yield put(actions.deleteTnSuccess());
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.deleteTnFail());
  }
}

export function* getTtnNextNumber({ payload }) {
  try {
    const response = yield call(post,
      '/ttn/next_number', payload);
    yield put(actions.getTtnNextNumberSuccess(response));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getTtnNextNumberFail());
  }
}

export function* delTtnNextNumber({ payload }) {
  try {
    yield call(del,
      `/ttn/next_number?plant=${payload.plantId}`);
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
  }
}

export function* getTransportCompanyList({ payload }) {
  try {
    const response = yield call(post, '/transport_company/list', payload);
    yield put(actions.getTransportCompanyListSuccess(response));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getTransportCompanyListFail());
  }
}

export function* addTransportCompany({ payload }) {
  try {
    yield call(post, '/transport_company', payload);
    yield put(actions.addTransportCompanySuccess());
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.addTransportCompanyFail());
  }
}

export function* getResponsiblePersonTn({ payload }) {
  try {
    const response = yield call(post, '/responsible_person/list', payload);
    yield put(actions.getResponsiblePersonListSuccess(response));
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getResponsiblePersonListFail());
  }
}

export function* addResponsiblePersonTn({ payload }) {
  try {
    yield call(post, '/responsible_person', payload);
    yield put(actions.addResponsiblePersonTnSuccess());
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.addResponsiblePersonTnFail());
  }
}

export function* deleteEntity({ payload }) {
  try {
    const { type } = payload;
    if (type) {
      switch (type) {
        case 'Driver':
          yield all(payload.id.map((id) => call(del, `/drivers/${id}`)));
          yield put(actions.deleteEntitySuccess());
          break;
        case 'Packing':
          yield all(payload.id.map((id) => call(del, `/packing/${id}`)));
          yield put(actions.deleteEntitySuccess());
          break;
        case 'Responsible person':
          yield all(payload.id.map((id) => call(del, `/responsible_person/${id}`)));
          yield put(actions.deleteEntitySuccess());
          break;
        case 'Transport company':
          yield all(payload.id.map((id) => call(del, `/transport_company/${id}`)));
          yield put(actions.deleteEntitySuccess());
          break;
        case 'Vehicle':
          yield all(payload.id.map((id) => call(del, `/vehicles/${id}`)));
          yield put(actions.deleteEntitySuccess());
          break;
        default:
          yield put(actions.deleteEntityFail());
      }
    }
  } catch (e) {
    yield put(
      modalErrorOpen({
        message: e.response.data.message,
        techInfo: e.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.deleteEntityFail());
  }
}
